import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllAccounts, decrementCurrentWizardStep, incrementCurrentWizardStep, resetAccountResultsLoaded, resetCurrentWizardStep, resetSelectAllClientAccounts, resetSelectedAccounts, selectAccount, selectClient, setAccountResultsLoaded, setImportType, setPortfolioImportType, toggleSelectAllClientAccounts, } from './actions';
import { CLIENT_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(resetCurrentWizardStep, () => {
    return 0;
}));
export const selectedClient = createReducer(null, on(selectClient, (state, { selectedClient: newClient }) => {
    return newClient;
}));
export const portfolioImportType = createReducer(CLIENT_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => {
    return newPortfolioImportType;
}));
export const selectedAccounts = createReducer([], on(selectAccount, (state, { selectedAccountId: newAccountId }) => {
    if (state.map((account) => account.id).includes(newAccountId)) {
        return state.filter((account) => account.id !== newAccountId);
    }
    return [...state, { id: newAccountId, importAsSingleHolding: false }];
}), on(setImportType, (state, { id, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(id)) {
        return state.map((account) => {
            if (account.id === id) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id, importAsSingleHolding }];
}), on(resetSelectedAccounts, () => {
    return [];
}), on(addAllAccounts, (state, { accounts: serializedAccounts }) => {
    return serializedAccounts.map((account) => {
        return { id: account.accountId, importAsSingleHolding: false };
    });
}));
export const selectAllClientAccounts = createReducer(false, on(toggleSelectAllClientAccounts, (state) => {
    return !state;
}), on(resetSelectAllClientAccounts, () => {
    return false;
}));
export const accountResultsLoaded = createReducer(false, on(setAccountResultsLoaded, (state, action) => {
    return action.loaded;
}), on(resetAccountResultsLoaded, () => {
    return false;
}));
export const pershingImportHoldings = combineReducers({
    currentWizardStepIndex,
    selectedClient,
    selectedAccounts,
    selectAllClientAccounts,
    portfolioImportType,
    accountResultsLoaded,
});
